import { withoutKey } from './utils.js';
export const applySpoofInfo = (spoofInfo) => (state) => {
    return { ...state, spoofInfo };
};
export const withoutSpoofInfo = withoutKey('spoofInfo');
export const selectSpoofedCountry = (state) => state.spoofInfo?.countryCode;
export const selectSpoofedCurrentPostal = (state) => state.spoofInfo?.postalCode;
export const selectSpoofedDma = (state) => state.spoofInfo?.dma;
